/* eslint-disable react/no-multi-comp */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import every from 'lodash/every';
import map from 'lodash/map';
import Bem from 'bemHelper';
import DataProvider from 'api/data-provider';

import 'styles/forum/common/_rules-list.scss';

const bemClassesRules = new Bem('rulesItem');

// Show rules for current forum and all parents.
class ShowRulesList extends Component {
  static propTypes = {
    className: PropTypes.string,
    data: PropTypes.arrayOf(PropTypes.shape({})),
    rulesFor: PropTypes.oneOf(['форума', 'клуба']).isRequired,
    trackAs: PropTypes.string
  };

  render() {
    const { className, data = [] } = this.props;

    if (
      every(data, it => !it.rules_info) ||
      !every(data, it => it.rules_info && it.rules_info.show > 0)
    ) return null;

    return (
      <>
        {map(data, (it = {}, index) => {
          const { rules_info = {} } = it;

          if (!!rules_info.show && rules_info.description) {
            return (
              <div key={index} {...bemClassesRules({ extra: className })}>
                <div {...bemClassesRules('mainText')}>
                  <span {...bemClassesRules('text')}>
                    <span
                      dangerouslySetInnerHTML={{ __html: `<!--noindex-->${rules_info.description}<!--/noindex-->` }} // eslint-disable-line
                    />
                  </span>
                </div>
              </div>
            );
          }

          return null;
        })}
      </>
    );
  }
}

export default class ShowRulesListProvider extends Component {
  static propTypes = {
    tree: PropTypes.string,
    preloaded: PropTypes.shape({}),
    trackAs: PropTypes.string,
    rulesFor: PropTypes.string
  };

  render() {
    const { tree, preloaded, trackAs, rulesFor } = this.props;

    return (
      <DataProvider
        url="forum/forum"
        query={{ 'tree-parent': tree }}
        preloaded={preloaded}
      >
        <ShowRulesList trackAs={trackAs} rulesFor={rulesFor} />
      </DataProvider>
    );
  }
}
